export default "__VITE_ASSET__ChYAhvY9__"